import React, { VoidFunctionComponent } from 'react';
import {
  CardListItem,
  CardListItemProps,
  CardListItemSize
} from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { WorkTimeEntryBreak } from 'record-it-time-common/entity/entities/WorkTimeEntry/WorkTimeEntryDto';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';

export type WorkTimeEntryBreakListItemProps =
  PropsWithoutChildren<CardListItemProps> & {
    workTimeEntryBreak: WorkTimeEntryBreak;
    onDelete: (workTimeEntryBreak: WorkTimeEntryBreak) => void;
  };

export const WorkTimeEntryBreakListItem: VoidFunctionComponent<WorkTimeEntryBreakListItemProps> =
  React.memo((props) => {
    const { workTimeEntryBreak, onDelete, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const handleDeleteIconClick = useEventCallback(() => {
      onDelete(workTimeEntryBreak);
    });

    return (
      <CardListItem
        size={CardListItemSize.Small}
        {...remainingProps}
      >
        <CardListItemTitle>
          {DateUtils.withCurrentTimezone().formatDateRange(
            workTimeEntryBreak.startDate,
            workTimeEntryBreak.endDate
          )}
        </CardListItemTitle>
        <CardListItemIconButton
          {...iconConfigurations.prefixed.listItem.deleteIcon}
          onClick={handleDeleteIconClick}
          data-testid="WorkTimeEntryBreakListItem.DeleteIcon"
        ></CardListItemIconButton>
      </CardListItem>
    );
  });
